import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const Warehouse = () => {
  return <ErpTablePage moduleKey="inv_warehouse" />;
};

export default Warehouse;